import { strayLabelsCypherExpr } from './stray'

/**
 * Detail bundle for a single Network node (Asset / NetworkSegment /
 * NetworkDevice). Dispatches on `labels(n)` so the client issues one
 * round-trip regardless of kind. Every CALL always emits one row
 * (collect/count) so non-applicable kinds collapse to empty lists rather
 * than wiping the outer RETURN.
 *
 * `treeParent` is the containing Asset / NetworkSegment / NetworkDevice
 * (with `treeParentKind` for the link), `siteParent` is the owning Site
 * when the node hangs directly off it. `computes` are the `Compute` nodes
 * contained here (CANE computers/servers), surfaced as cross-links into
 * the Compute tab.
 *
 * Params: `{ nodeId: string }`.
 */
export const PLANT_NETWORK_NODE_DETAIL_CYPHER = `
            MATCH (n {id: $nodeId})
              WHERE (n:Asset OR n:NetworkSegment OR n:NetworkDevice)
            WITH n, labels(n) AS labelList
            CALL {
              WITH n
              OPTIONAL MATCH (n)<-[:CONTAINS]-(p)
                WHERE (p:Asset OR p:NetworkSegment OR p:NetworkDevice)
              WITH p LIMIT 1
              RETURN p AS treeParent,
                     CASE
                       WHEN p:Asset THEN 'Asset'
                       WHEN p:NetworkSegment THEN 'NetworkSegment'
                       WHEN p:NetworkDevice THEN 'NetworkDevice'
                       ELSE null
                     END AS treeParentKind
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)<-[:CONTAINS]-(s:Site)
              RETURN collect(s)[0] AS siteParent
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(a:Asset)
              RETURN collect(distinct a) AS childAssets
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(seg:NetworkSegment)
              RETURN collect(distinct seg) AS childSegments
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(dev:NetworkDevice)
              RETURN collect(distinct dev) AS childDevices
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:CONTAINS]->(c:Compute)
              RETURN collect(distinct c) AS computes
            }
            CALL {
              WITH n
              OPTIONAL MATCH (n)-[:BELONGS_TO]->(proj:EmdbProject)
              RETURN collect(proj)[0] AS project
            }
            RETURN n, labelList,
                   treeParent, treeParentKind, siteParent, project,
                   childAssets, childSegments, childDevices, computes,
                   ${strayLabelsCypherExpr('n', 'labelList')} AS strayLabels
            LIMIT 10000
          `
